module.exports = __webpack_public_path__ + "img/top.824e3667.jpg";